import { Popover } from '@bufferapp/components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { useSplitEnabled } from '@bufferapp/features';

import { actions } from '../../reducer';
import ComposerWrapper from '../ComposerWrapper';

const ComposerPopover = ({
  onSave,
  transparentOverlay,
  shouldResetComposerData,
  onConfirmDismissComposer,
  type,
}) => {
  const { isEnabled: newComposerStyles } = useSplitEnabled(
    'composer-new-height'
  );
  const [showDismissComposerModal, setShowDismissComposerModal] =
    useState(false);

  const onOverlayClick = () => {
    setShowDismissComposerModal(true);
  };

  const handleCancelDismissModal = () => {
    setShowDismissComposerModal(false);
  };

  const handleConfirmDismissComposer = () => {
    setShowDismissComposerModal(false);
    onConfirmDismissComposer();
  };

  return (
    <Popover
      width="100%"
      top={newComposerStyles ? null : '6.7%'}
      transparentOverlay={transparentOverlay}
      onOverlayClick={onOverlayClick}
    >
      <ComposerWrapper
        type={type}
        onSave={onSave}
        shouldResetComposerData={shouldResetComposerData}
        onCancelDismissModal={handleCancelDismissModal}
        onConfirmDismissComposer={handleConfirmDismissComposer}
        showDismissComposerModal={showDismissComposerModal}
        onComposerOverlayClick={onOverlayClick}
      />
    </Popover>
  );
};

ComposerPopover.propTypes = {
  onSave: PropTypes.func.isRequired,
  onConfirmDismissComposer: PropTypes.func,
  shouldResetComposerData: PropTypes.bool,
  transparentOverlay: PropTypes.bool,
  type: PropTypes.oneOf([
    'queue',
    'drafts',
    'sent',
    'pastReminders',
    'composerPopover',
    'campaigns',
  ]),
};

ComposerPopover.defaultProps = {
  transparentOverlay: false,
  shouldResetComposerData: false,
  onConfirmDismissComposer: () => {
    actions.hideComposer();
  },
  type: 'queue',
};

export default hot(ComposerPopover);
